import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "example-bulk-operations-implementation"
    }}>{`Example bulk operations implementation`}</h1>
    <p>{`This document describes how bulk operations can be implemented. There are three primary tasks to accomplish this:`}</p>
    <ul>
      <li parentName="ul">{`Create a publisher that sends messages to the message queue`}</li>
      <li parentName="ul">{`Create a consumer that receives and processes messages`}</li>
      <li parentName="ul">{`Configure the message queues`}</li>
    </ul>
    <h2 {...{
      "id": "create-a-publisher"
    }}>{`Create a publisher`}</h2>
    <p>{`A publisher's duties include scheduling a bulk operation. It must generate a `}<inlineCode parentName="p">{`bulkUuid`}</inlineCode>{` for each operation, send each operation to the message queue, and report on the status of each operations.`}</p>
    <p>{`The following code sample shows how these duties can be completed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`<?php
/**
 * Copyright [first year code created] Adobe
 * All rights reserved.
 */

use Magento\\AsynchronousOperations\\Api\\Data\\OperationInterface;
use Magento\\AsynchronousOperations\\Api\\Data\\OperationInterfaceFactory;
use Magento\\Authorization\\Model\\UserContextInterface;
use Magento\\Framework\\Bulk\\BulkManagementInterface;
use Magento\\Framework\\DataObject\\IdentityGeneratorInterface;
use Magento\\Framework\\Exception\\LocalizedException;
use Magento\\Framework\\Json\\Helper\\Data as JsonHelper;
use Magento\\Framework\\UrlInterface;

/**
 * Class ScheduleBulk
 */
class ScheduleBulk
{
    /**
     * @var BulkManagementInterface
     */
    private $bulkManagement;

    /**
     * @var OperationInterfaceFactory
     */
    private $operationFactory;

    /**
     * @var IdentityGeneratorInterface
     */
    private $identityService;

    /**
     * @var UrlInterface
     */
    private $urlBuilder;

    /**
     * @var UserContextInterface
     */
    private $userContext;

    /**
     * @var JsonHelper
     */
    private $jsonHelper;

    /**
     * ScheduleBulk constructor.
     *
     * @param BulkManagementInterface $bulkManagement
     * @param OperationInterfaceFactory $operationFactory
     * @param IdentityGeneratorInterface $identityService
     * @param UserContextInterface $userContextInterface
     * @param UrlInterface $urlBuilder
     */
    public function __construct(
        BulkManagementInterface $bulkManagement,
        OperationInterfaceFactory $operationFactory,
        IdentityGeneratorInterface $identityService,
        UserContextInterface $userContextInterface,
        UrlInterface $urlBuilder,
        JsonHelper $jsonHelper
    ) {
        $this->userContext = $userContextInterface;
        $this->bulkManagement = $bulkManagement;
        $this->operationFactory = $operationFactory;
        $this->identityService = $identityService;
        $this->urlBuilder = $urlBuilder;
        $this->jsonHelper = $jsonHelper;

    }

    /**
     * Schedule new bulk operation
     *
     * @param array $operationData
     * @throws LocalizedException
     * @return void
     */
    public function execute($operationData)
    {
        $operationCount = count($operationData);
        if ($operationCount > 0) {
            $bulkUuid = $this->identityService->generateId();
            $bulkDescription = 'Specify here your bulk description';

            $operations = [];
            foreach ($operationData as $operation) {

                $serializedData = [
                    //this data will be displayed in Failed item grid in ID column
                    'entity_id' => $operation['entity_id'],
                    //add here logic to add url for your entity(this link will be displayed in the Failed item grid)
                    'entity_link' => $this->urlBuilder->getUrl('your_url'),
                    //this data will be displayed in Failed item grid in the column "Meta Info"
                    'meta_information' => 'Specify here meta information for your entity',//this data will be displayed in Failed item grid in the column "Meta Info"
                ];
                $data = [
                    'data' => [
                        'bulk_uuid' => $bulkUuid,
                        //topic name must be equal to data specified in the queue configuration files
                        'topic_name' => '%your_topic name%',
                        'serialized_data' => $this->jsonHelper->jsonEncode($serializedData),
                        'status' => OperationInterface::STATUS_TYPE_OPEN,
                    ]
                ];

                /** @var OperationInterface $operation */
                $operation = $this->operationFactory->create($data);
                $operations[] = $operation;

            }
            $userId = $this->userContext->getUserId();
            $result = $this->bulkManagement->scheduleBulk($bulkUuid, $operations, $bulkDescription, $userId);
            if (!$result) {
                throw new LocalizedException(
                    __('Something went wrong while processing the request.')
                );
            }
        }
    }
}
`}</code></pre>
    <h2 {...{
      "id": "create-a-consumer"
    }}>{`Create a consumer`}</h2>
    <p>{`A consumer class receives messages from the message queue and changes the status after it is processed. The following example defines a consumer that handles price update bulk operations.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`<?php
/**
 * Copyright [first year code created] Adobe
 * All rights reserved.
 */

namespace Magento\\SharedCatalog\\Model\\ResourceModel\\ProductItem\\Price;

use Magento\\AsynchronousOperations\\Api\\Data\\OperationInterface;
use Magento\\AsynchronousOperations\\Api\\Data\\OperationInterfaceFactory;
use Magento\\Framework\\Bulk\\BulkManagementInterface;
use Magento\\Framework\\Bulk\\OperationManagementInterface;
use Magento\\Framework\\DB\\Adapter\\ConnectionException;
use Magento\\Framework\\DB\\Adapter\\DeadlockException;
use Magento\\Framework\\DB\\Adapter\\LockWaitException;
use Magento\\Framework\\Exception\\LocalizedException;
use Magento\\Framework\\Exception\\NoSuchEntityException;
use Magento\\Framework\\Exception\\TemporaryStateExceptionInterface;
use Magento\\Framework\\Json\\Helper\\Data as JsonHelper;
use Psr\\Log\\LoggerInterface;

/**
 * Class Consumer
 */
class Consumer
{
    /**
     * @var LoggerInterface
     */
    private $logger;

    /**
     * @var JsonHelper
     */
    private $jsonHelper;

    /**
     * @var OperationManagementInterface
     */
    private $operationManagement;

    /**
     * Consumer constructor.
     *
     * @param LoggerInterface $logger
     * @param JsonHelper $jsonHelper
     */
    public function __construct(
        LoggerInterface $logger,
        JsonHelper $jsonHelper,
        OperationManagementInterface $operationManagement
    ) {
        $this->logger = $logger;
        $this->jsonHelper = $jsonHelper;
        $this->operationManagement = $operationManagement;
    }

    /**
     * Processing operation for update price
     *
     * @param OperationInterface $operation
     * @return void
     */
    public function processOperation(OperationInterface $operation)
    {
        $status = OperationInterface::STATUS_TYPE_COMPLETE;
        $errorCode = null;
        $message = null;
        $serializedData = $operation->getSerializedData();
        $unserializedData = $this->jsonHelper->jsonDecode($serializedData);
        try {
            //add here your own logic for async operations
        } catch (\\Zend_Db_Adapter_Exception  $e) {
            //here sample how to process exceptions if they occurred
            $this->logger->critical($e->getMessage());
            //you can add here your own type of exception when operation can be retried
            if (
                $e instanceof LockWaitException
                || $e instanceof DeadlockException
                || $e instanceof ConnectionException
            ) {
                $status = OperationInterface::STATUS_TYPE_RETRIABLY_FAILED;
                $errorCode = $e->getCode();
                $message = __($e->getMessage());
            } else {
                $status = OperationInterface::STATUS_TYPE_NOT_RETRIABLY_FAILED;
                $errorCode = $e->getCode();
                $message = __('Sorry, something went wrong during product prices update. Please see log for details.');
            }

        } catch (NoSuchEntityException $e) {
            $this->logger->critical($e->getMessage());
            $status = ($e instanceof TemporaryStateExceptionInterface) ? OperationInterface::STATUS_TYPE_NOT_RETRIABLY_FAILED : OperationInterface::STATUS_TYPE_NOT_RETRIABLY_FAILED;
            $errorCode = $e->getCode();

            $message = $e->getMessage();
            unset($unserializedData['entity_link']);
            $serializedData = $this->jsonHelper->jsonEncode($unserializedData);
        } catch (LocalizedException $e) {
            $this->logger->critical($e->getMessage());
            $status = OperationInterface::STATUS_TYPE_NOT_RETRIABLY_FAILED;
            $errorCode = $e->getCode();
            $message = $e->getMessage();
        } catch (\\Exception $e) {
            $this->logger->critical($e->getMessage());
            $status = OperationInterface::STATUS_TYPE_NOT_RETRIABLY_FAILED;
            $errorCode = $e->getCode();
            $message = __('Sorry, something went wrong during product prices update. Please see log for details.');
        }

        //update operation status based on result performing operation(it was successfully executed or exception occurs
        $this->operationManagement->changeOperationStatus(
            $operation->getId(),
            $status,
            $errorCode,
            $message,
            $serializedData
        );
    }
}
`}</code></pre>
    <h2 {...{
      "id": "configure-message-queues"
    }}>{`Configure message queues`}</h2>
    <p>{`The message queue topology must be configured to implement bulk operations. Create or edit the following files in the module's `}<inlineCode parentName="p">{`app/code/<vendor>/<module_name>/etc`}</inlineCode>{` directory.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`communication.xml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`di.xml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_consumer.xml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_publisher.xml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`queue_topology.xml`}</inlineCode></li>
    </ul>
    <p>{`For more information about the `}<inlineCode parentName="p">{`di.xml`}</inlineCode>{` file, see `}<a parentName="p" {...{
        "href": "../dependency-injection.md"
      }}>{`Dependency Injection`}</a>{`. For information the other files, see `}<a parentName="p" {...{
        "href": "configuration.md"
      }}>{`Configure message queues`}</a>{`.`}</p>
    <h3 {...{
      "id": "create-communicationxml"
    }}>{`Create `}<inlineCode parentName="h3">{`communication.xml`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`communication.xml`}</inlineCode>{` file defines aspects of the message queue system that apply to all topics for the module. Create this file with the following contents:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:framework:Communication/etc/communication.xsd">
    <topic name="<your_topic_name>" request="Magento\\AsynchronousOperations\\Api\\Data\\OperationInterface">
        <handler name="<your_handler_name>" type="<Consumer_Class>" method="<consumer_method>" />
    </topic>
</config>
`}</code></pre>
    <h3 {...{
      "id": "create-dixml"
    }}>{`Create `}<inlineCode parentName="h3">{`di.xml`}</inlineCode></h3>
    <p>{`Add the following type to the module's `}<inlineCode parentName="p">{`di.xml`}</inlineCode>{` file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<type name="Magento\\Framework\\MessageQueue\\MergerFactory">
    <arguments>
        <argument name="mergers" xsi:type="array">
            <item name="<your_consumer_name>" xsi:type="string"><Merger_Class></item>
        </argument>
    </arguments>
</type>
`}</code></pre>
    <h3 {...{
      "id": "create-queue_consumerxml"
    }}>{`Create `}<inlineCode parentName="h3">{`queue_consumer.xml`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`queue_consumer.xml`}</inlineCode>{` file defines the relationship between a queue and its consumer. Create this file with the following contents:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:framework-message-queue:etc/consumer.xsd">
    <consumer name="<consumer_name>" queue="<queue_name>" connection="amqp" consumerInstance="Magento\\Framework\\MessageQueue\\Consumer" handler="<Consumer_Class>::<Consumer_method>"/>
</config>
`}</code></pre>
    <h3 {...{
      "id": "create-queue_publisherxml"
    }}>{`Create `}<inlineCode parentName="h3">{`queue_publisher.xml`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`queue_publisher.xml`}</inlineCode>{` file defines the exchange where a topic is published. Create this file with the following contents:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:framework-message-queue:etc/publisher.xsd">
    <publisher topic="<topic_name>">
        <connection name="amqp" exchange="<exchange>" />
    </publisher>
</config>
`}</code></pre>
    <h3 {...{
      "id": "create-queue_topologyxml"
    }}>{`Create `}<inlineCode parentName="h3">{`queue_topology.xml`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`queue_topology.xml`}</inlineCode>{` file defines the message routing rules and declares queues and exchanges. Create this file with the following contents:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:framework-message-queue:etc/topology.xsd">
    <exchange name="magento" type="topic" connection="amqp">
        <binding id="defaultBinding" topic="" destinationType="queue" destination="<queue_name>"/>
    </exchange>
</config>
`}</code></pre>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Message queue connections are defined dynamically, based on the deployment configuration in the `}<inlineCode parentName="p">{`env.php`}</inlineCode>{` file. If AMQP is configured in the deployment configuration of the queue, AMQP connections are used. Otherwise, database connections are used.
As a result, if AMQP is configured in the deployment configuration of the queue, you can omit connection declarations in the `}<inlineCode parentName="p">{`queue_consumer.xml`}</inlineCode>{`, `}<inlineCode parentName="p">{`queue_publisher.xml`}</inlineCode>{`, and `}<inlineCode parentName="p">{`queue_topology.xml`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "./configuration.md"
      }}>{`message queue configuration files`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      